module.exports = __webpack_public_path__ + "../assets/img/d86dda209727604b758fa626b7c8cf38.svg";